import React from 'react';

function App() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-sky-400 to-indigo-500 text-white">
      <h1 className="text-5xl font-bold mb-4">Torque Tees</h1>
      <p className="text-xl mb-6">STEM Apparel for the Bold and Brilliant</p>
      <a href="#shop" className="px-6 py-3 bg-white text-indigo-700 rounded-full font-semibold hover:bg-gray-100">
        Shop Now
      </a>
    </div>
  );
}

export default App;
